import { ProductWithAttributes } from '../types';

export const isProductInGroup = (
  product: ProductWithAttributes,
  groupValue: string
): boolean => {
  if (!product.attributes?.items) return false;
  const productGroupAttr = product.attributes.items.find(
    (attr) => attr.code === 'product_group'
  );
  if (!productGroupAttr?.selected_options) return false;
  return productGroupAttr.selected_options.some(
    (opt) => opt.value === groupValue
  );
};
